import React, { Component } from "react";
import { connect } from "react-redux";

import { push } from "react-router-redux";
import LinearProgress from "@material-ui/core/LinearProgress";

const mapStateToProps = state => ({
  auth: state.user.auth
});

const mapDispatchToProps = dispatch => ({
  routeToHome: () => dispatch(push("/"))
});

class DefaultAccount extends Component {
  componentDidMount() {
    const { auth, routeToHome } = this.props;
    return auth ? null : routeToHome();
  }
  render() {
    return <LinearProgress />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultAccount);



// WEBPACK FOOTER //
// ./src/pages/default_dashboard/DefaultAccountPage.js